// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .size-chart-dropdown .ant-select-item-option-content {
  white-space: normal;
  word-break: break-all;
}
.presize-root .size-chart-dropdown .create-size-chart {
  font-weight: bold;
}
.presize-root .size-chart-dropdown .rds-link {
  font-weight: normal;
  border-bottom: none;
  text-decoration: underline;
  font-size: inherit;
  display: inline-block;
}
.presize-root .overwrite-sizing-confirm {
  width: 350px;
}
/*# sourceMappingURL=SizingPicker.css.map */`, "",{"version":3,"sources":["webpack://./SizingPicker.less","webpack://./src/components/SizingPicker/SizingPicker.less"],"names":[],"mappings":"AAAA;EAGI,mBAAA;EACA,qBAAA;ACDJ;ADHA;EAOI,iBAAA;ACDJ;ADNA;EAUI,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;ACDJ;ADbA;EAkBE,YAAA;ACFF;AACA,2CAA2C","sourcesContent":[".presize-root { \n .size-chart-dropdown {\n  .ant-select-item-option-content {\n    white-space: normal;\n    word-break: break-all;\n  }\n  .create-size-chart {\n    font-weight: bold;\n  }\n  .rds-link {\n    font-weight: normal;\n    border-bottom: none;\n    text-decoration: underline;\n    font-size: inherit;\n    display: inline-block;\n  }\n}\n.overwrite-sizing-confirm {\n  width: 350px;\n}\n \n}",".presize-root .size-chart-dropdown .ant-select-item-option-content {\n  white-space: normal;\n  word-break: break-all;\n}\n.presize-root .size-chart-dropdown .create-size-chart {\n  font-weight: bold;\n}\n.presize-root .size-chart-dropdown .rds-link {\n  font-weight: normal;\n  border-bottom: none;\n  text-decoration: underline;\n  font-size: inherit;\n  display: inline-block;\n}\n.presize-root .overwrite-sizing-confirm {\n  width: 350px;\n}\n/*# sourceMappingURL=SizingPicker.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
